import { navigateTo } from '#imports'

import { CHECKOUT } from '~/scopes/checkout/routes-names'

const MOBILE_PLAN_ERROR = {
  NO_ACCESS_TOKEN: 'No access token set',
  NO_PHONELINE_SETUP_INFORMATION: 'No phoneline setup information set',
}

export async function handleMobilePlanErrors(error: Error) {
  if (error.message === MOBILE_PLAN_ERROR.NO_ACCESS_TOKEN) {
    navigateTo({ name: CHECKOUT.SERVICES.BOUYGUES.SIGN_UP })
  }

  if (error.message === MOBILE_PLAN_ERROR.NO_PHONELINE_SETUP_INFORMATION) {
    navigateTo({ name: CHECKOUT.SERVICES.BOUYGUES.PHONELINE_SETUP })
  }
}
